import {connect} from "react-redux";

import * as AuthActions from "../store/actions/authActions";
import Verify from "../components/Verify";
import * as AppActions from '../store/actions/appActions';

const mapStateToProps = (state) => ({
    ...state.auth
});

const mapDispatchToProps = (dispatch) => ({
    requestPasswordReset: (email) => {
        dispatch(AuthActions.sendForgotPasswordEmail(email));
    },
    resetPassword: (token, password) => {
        dispatch(AuthActions.resetPassword(token, password));
    },
    hideLoader: () => {
        dispatch(AppActions.appLoading(false));
    },
    resetPasswordStatus: () => {
        dispatch(AuthActions.resetPasswordResetStatus());
    },
    authClear: () => {
        dispatch(AuthActions.clearErrors());
    },
    sendToken: (user, token) => {
        dispatch(AuthActions.sendToken(user, token));
    },
    verifyWithCode: (user, code, email) => {
        dispatch(AuthActions.verifyCode(user, code, email));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Verify);


// WEBPACK FOOTER //
// ./src/containers/VerifyContainer.js